import Loadingrequest from '../../components/loading-request';
function Loading(params) {
  return (
    <>
    <Loadingrequest/>
</>
  )
}

export default Loading;